import { render, staticRenderFns } from "./ResourcesList.vue?vue&type=template&id=1ce32744&scoped=true"
import script from "./ResourcesList.vue?vue&type=script&lang=ts"
export * from "./ResourcesList.vue?vue&type=script&lang=ts"
import style0 from "./ResourcesList.vue?vue&type=style&index=0&id=1ce32744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce32744",
  null
  
)

export default component.exports